module.exports = __webpack_public_path__ + "static/media/walls.c797e793.svg";